(function () {
  'use strict';
  var root = document.querySelector('[data-jewellery-filter]');
  var measurement = window.HonnarasMeasurements;
  if (!root || !measurement) return;
  var dialog = root.querySelector('dialog');
  var form = root.querySelector('[data-jfit-form]');
  var fields = root.querySelector('[data-jfit-fields]');
  var status = root.querySelector('[data-jfit-status]');
  var preview = root.querySelector('[data-jfit-preview]');
  var apply = root.querySelector('[data-jfit-apply]');
  var retry = root.querySelector('[data-jfit-retry]');
  var openButton = root.querySelector('[data-jfit-open]');
  var summary = root.querySelector('[data-jfit-summary]');
  var grid = document.getElementById('hna-grid');
  var ready = false, loading = false, records = [], selection = {};
  var previousOverflow = '', opener = null;
  var axes = Object.keys(measurement.names);
  var url = new URL(location.href);
  axes.forEach(function (key) {
    var value = url.searchParams.get('j_' + key);
    if (value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) > 0) selection[key] = value;
  });
  if (url.searchParams.has('j_match')) {
    url.searchParams.delete('j_match');
    history.replaceState(history.state, '', url);
  }

  function announce() {
    updateCards();
    document.dispatchEvent(new CustomEvent('honnaras:measurement-filter', { detail: {
      matches: function (card) { return measurement.matches(measurement.parse(card.dataset.measurements || '', card.dataset.sizeValues || ''), selection); },
      active: function () { return measurement.selectedEntries(selection).length > 0; },
      clear: function () { selection = {}; persist('all'); updateSummary(); updateCards(); },
      updateCount: function (count) {
        if (measurement.selectedEntries(selection).length) summary.textContent = count + ' ' + (count === 1 ? 'ornament' : 'ornaments') + ' shown. ' + selectionLabel() + '.';
      }
    }}));
  }
  function updateCards() {
    grid.querySelectorAll('.hna-card').forEach(function (card) {
      var labels = measurement.matchedLabels(measurement.parse(card.dataset.measurements || '', card.dataset.sizeValues || ''), selection);
      var note = card.querySelector('[data-jfit-card-match]');
      if (!labels.length) { if (note) note.remove(); return; }
      if (!note) {
        note = document.createElement('p'); note.className = 'jfit__card-match'; note.dataset.jfitCardMatch = '';
        card.querySelector('.hna-card__title').insertAdjacentElement('afterend', note);
      }
      note.textContent = 'Matches: ' + labels.join(' / ');
    });
  }
  function persist(value) {
    var next = new URL(location.href);
    axes.forEach(function (key) {
      next.searchParams.delete('j_' + key);
      if (selection[key] !== undefined) next.searchParams.set('j_' + key, selection[key]);
    });
    next.searchParams.set('jfit', value);
    next.searchParams.delete('j_match');
    // The grid now contains the full collection, so an old page number is misleading.
    next.searchParams.delete('page');
    history.replaceState(history.state, '', next);
  }
  function selectionLabel() {
    return measurement.selectedEntries(selection).map(function (key) {
      var select = fields.querySelector('[data-axis="' + key + '"]');
      var option = select && Array.from(select.options).find(function (item) { return item.value === String(selection[key]); });
      return measurement.names[key] + ': ' + (option ? option.textContent : (Number(selection[key]) / 25.4).toFixed(2) + ' inches');
    }).join(' · ');
  }
  function updateSummary() {
    summary.textContent = measurement.selectedEntries(selection).length ? selectionLabel() : 'Choose measurements to find ornaments for your idol.';
    openButton.textContent = measurement.selectedEntries(selection).length ? 'Change measurements' : 'Choose measurements';
  }
  function readDraft() {
    var draft = {};
    fields.querySelectorAll('select').forEach(function (select) { if (select.value) draft[select.dataset.axis] = select.value; });
    return draft;
  }
  function updatePreview() {
    if (!ready) return;
    var draft = readDraft();
    var keys = measurement.selectedEntries(draft);
    var count = records.filter(function (record) { return measurement.matches(record, draft); }).length;
    preview.textContent = count ? count + (count === 1 ? ' ornament matches' : ' ornaments match') + ' in this category.' : 'No exact matches. Try another measurement or Browse all.';
    apply.textContent = keys.length ? 'Show ' + count + ' ' + (count === 1 ? 'ornament' : 'ornaments') : 'Show all ornaments';
    apply.disabled = keys.length > 0 && count === 0;
    root.querySelector('[data-jfit-note]').hidden = !keys.length || !records.some(function (record) { return !Object.keys(record.dimensions).length && !record.universal; });
  }
  function restoreDraft() {
    fields.querySelectorAll('select').forEach(function (select) { select.value = selection[select.dataset.axis] || ''; });
    updatePreview();
  }
  function open() {
    if (dialog.open || typeof dialog.showModal !== 'function') return;
    restoreDraft();
    opener = document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    root.querySelector('.jfit__body').scrollTop = 0;
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', function () {
    document.body.style.overflow = previousOverflow;
    if (!url.searchParams.has('jfit') && !new URL(location.href).searchParams.has('jfit')) persist('all');
    if (opener && opener.isConnected && opener !== document.body) opener.focus();
  });
  root.querySelector('[data-jfit-close]').addEventListener('click', close);
  root.querySelector('[data-jfit-browse]').addEventListener('click', function () {
    selection = {}; persist('all'); updateSummary();
    if (ready) announce();
    close();
  });
  openButton.addEventListener('click', open);
  form.addEventListener('change', updatePreview);
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!ready || apply.disabled) return;
    selection = readDraft();
    persist('1'); updateSummary(); announce(); close();
    root.scrollIntoView({ block: 'start', behavior: 'instant' });
    openButton.focus({ preventScroll: true });
  });

  function buildFields() {
    fields.replaceChildren();
    axes.forEach(function (key) {
      var choices = measurement.choices(records, key);
      if (!choices.length) return;
      var label = document.createElement('label'); label.className = 'jfit__field';
      var text = document.createElement('span'); text.textContent = measurement.names[key];
      var select = document.createElement('select'); select.dataset.axis = key; select.name = 'j_' + key;
      select.add(new Option('Any ' + measurement.names[key].toLowerCase(), ''));
      choices.forEach(function (choice) { select.add(new Option(choice.label, String(choice.value))); });
      if (selection[key] && !choices.some(function (choice) { return String(choice.value) === selection[key]; })) {
        var value = Number(selection[key]);
        // Keep shared links usable when a selected measurement falls inside a source range.
        select.add(new Option(roundedInches(value) + ' inches', String(value)));
      }
      label.append(text, select); fields.append(label);
    });
    status.textContent = fields.children.length ? 'Choose the ornament measurements. Idol height is shown separately when supplied.' : records.every(function (record) { return record.universal; }) ? 'These ornaments are suitable for all sizes of Fiber Idols.' : 'Measurements are not listed for these ornaments. Browse all and check the size guide.';
    status.hidden = fields.children.length > 0;
    restoreDraft();
  }
  function roundedInches(value) { return Math.round(value / 25.4 * 100) / 100; }
  async function fetchPage(pageUrl) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(pageUrl, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection request failed');
      var html = await response.text();
      var documentPage = new DOMParser().parseFromString(html, 'text/html');
      var catalog = documentPage.querySelector('[data-jewellery-catalog]');
      if (!catalog) throw new Error('Collection data missing');
      return catalog;
    } finally { clearTimeout(timeout); }
  }
  async function load() {
    if (loading || ready) return;
    loading = true; retry.hidden = true; status.hidden = false; status.textContent = "Loading this category's measurements...";
    apply.disabled = true;
    try {
      var endpoint = new URL(location.href);
      Array.from(endpoint.searchParams.keys()).forEach(function (key) {
        if (key === 'page' || key.startsWith('page_') || key === 'jfit' || key.startsWith('j_')) endpoint.searchParams.delete(key);
      });
      endpoint.searchParams.set('section_id', 'jewellery-collection-data');
      var page = await fetchPage(endpoint);
      var total = Number(page.dataset.total);
      var cards = Array.from(page.querySelectorAll('.hna-card'));
      var seen = new Set([endpoint.href]);
      while (page.dataset.next) {
        var next = new URL(page.dataset.next, location.origin);
        if (next.origin !== location.origin || next.pathname !== endpoint.pathname) throw new Error('Invalid next page');
        next.searchParams.set('section_id', 'jewellery-collection-data');
        if (seen.has(next.href)) throw new Error('Repeated collection page');
        seen.add(next.href);
        page = await fetchPage(next);
        cards.push.apply(cards, Array.from(page.querySelectorAll('.hna-card')));
      }
      if (cards.length !== total || new Set(cards.map(function (card) { return card.dataset.productId; })).size !== total) throw new Error('Incomplete collection');
      records = cards.map(function (card) { return measurement.parse(card.dataset.measurements || '', card.dataset.sizeValues || ''); });
      var fragment = document.createDocumentFragment();
      cards.forEach(function (card, index) { card.dataset.order = index; fragment.append(card); });
      grid.querySelectorAll('.hna-card').forEach(function (card) { card.remove(); });
      grid.prepend(fragment);
      var pagination = grid.parentElement.querySelector('.hna-pagination');
      if (pagination) pagination.hidden = true;
      ready = true;
      buildFields(); updateSummary(); announce();
      var sort = grid.parentElement.querySelector('.hna-sort-select');
      if (sort && sort.value !== 'manual') sort.dispatchEvent(new Event('change'));
    } catch (error) {
      status.textContent = "We couldn't load the whole category. Try again, or choose Browse all to keep shopping.";
      retry.hidden = false;
    } finally { loading = false; }
  }
  retry.addEventListener('click', load);
  load();
  if (!url.searchParams.has('jfit')) open();
})();
